import { type PartialPropsOf } from '@blaze-runtime/engine-domain';
import { type PropertiesConfigInputVisualEffectModel } from '@blaze-shared/elements-domain';

import { PropsBuilder } from '../__base/props-builder';

export class HtmlCardPropsBuilder extends PropsBuilder<'htmlCard'> {
  override setVisualEffect = (
    visualEffect: PropertiesConfigInputVisualEffectModel | undefined,
  ): this => {
    this.patchProps({ style: { container: { visualEffect } } });
    return this;
  };

  constructor(props: PartialPropsOf<'htmlCard'> | undefined) {
    super(props, { hasData: true, hasLabel: true });
  }
}
